import { QUESTION_TYPES } from '@/utils/constants'
import { removeUndefinedProperties } from '@/utils/object'

const RUN_ON_ALL = '*'

const surveyLoadParsers = {
  [RUN_ON_ALL]: {
    parseNoneOfTheAbove: (question, allQuestions) => {
      const {
        advancedOptions: { none_of_the_above },
      } = question

      if (!none_of_the_above) return question

      const { logic } = none_of_the_above

      const refQuestion = allQuestions.find(({ code }) => code === logic)

      if (!refQuestion) return question

      return {
        ...question,
        advancedOptions: {
          ...question.advancedOptions,
          none_of_the_above: {
            ...none_of_the_above,
            logic: refQuestion.qid,
          },
        },
      }
    },
  },

  [QUESTION_TYPES.number]: {
    numericMaxMinReferences: (question, allQuestions) => {
      const {
        advancedOptions: { max_value_reference, min_value_reference },
      } = question

      if (!max_value_reference && !min_value_reference) return question

      const [maxId, minId] = [max_value_reference, min_value_reference].map(
        questionCode => allQuestions.find(({ code }) => code === questionCode)?.qid,
      )

      return {
        ...question,
        advancedOptions: removeUndefinedProperties({
          ...question.advancedOptions,
          max_value_reference: maxId,
          min_value_reference: minId,
        }),
      }
    },
  },
}

const uploadUploadParsers = {
  [QUESTION_TYPES.number]: {
    numericMaxMinReferences: (question, allQuestions) => {
      const {
        advancedOptions: { max_value_reference, min_value_reference },
      } = question

      if (!max_value_reference && !min_value_reference) return question

      const [maxCode, minCode] = [max_value_reference, min_value_reference].map(
        questionId => allQuestions.find(({ qid }) => qid === questionId)?.code,
      )

      return {
        ...question,
        advancedOptions: removeUndefinedProperties({
          ...question.advancedOptions,
          max_value_reference: maxCode,
          min_value_reference: minCode,
        }),
      }
    },
  },

  [RUN_ON_ALL]: {
    parseNoneOfTheAbove: (question, allQuestions) => {
      const {
        advancedOptions: { none_of_the_above },
      } = question

      if (!none_of_the_above) return question

      const { logic } = none_of_the_above

      const refQuestion = allQuestions.find(({ qid }) => qid === logic)

      if (!refQuestion) return question

      return {
        ...question,
        advancedOptions: {
          ...question.advancedOptions,
          none_of_the_above: {
            ...none_of_the_above,
            logic: refQuestion.code,
          },
        },
      }
    },
  },
}

function applyParsersToQuestion(question, allQuestions, parsers) {
  const { type } = question

  const questionParsers = Object.values({
    ...parsers[RUN_ON_ALL],
    ...parsers[type],
  })

  if (!questionParsers.length) return question

  const updatedQuestion = questionParsers.reduce(
    (acc, parser) => parser(acc, allQuestions),
    question,
  )

  return updatedQuestion
}

function getParser(parsers) {
  return questionGroups => {
    const allQuestions = questionGroups.map(({ questions }) => questions).flat()

    return questionGroups.map(({ questions, ...rest }) => ({
      ...rest,
      questions: questions.map(question =>
        applyParsersToQuestion(question, allQuestions, parsers),
      ),
    }))
  }
}

export const parseQuestionsBeforeSaving = getParser(uploadUploadParsers)

export const parseQuestionsOnLoad = getParser(surveyLoadParsers)
